import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Lightbox } from 'ngx-lightbox';
import Employee from 'src/app/model/product/employee';
import { ImmoStudioEmployeeAggregates } from 'src/app/model/tour/immo-studio-employee-aggregates';
import { AtelierService } from 'src/app/services/atelier-service';
import DateHelper from '../../../../helpers/date-helper';
import { ImmoStudioEmployee } from '../../../../model/tour/immo-studio-employee';
import { ImmoStudioTour } from '../../../../model/tour/immo-studio-tour';
import { AtelierUnassignTourControllerRequestService } from '../../../../services/api/atelier/atelier-unassign-tour-controller-request.service';
import { SubProjectControllerRequestService } from '../../../../services/api/sub-project-controller-request.service';
import { FilterStoreService } from '../../../../services/filter-store.service';
import { ModalService } from '../../../../services/modal.service';
import { PageIndexService } from '../../../../services/page-index-service';
import { EmployeeTourEditModalComponent } from '../../tour/tour-page/employee-tour-edit-modal/employee-tour-edit-modal.component';
import { IPInstallerListControllerRequestService } from '../../tour/tour-page/service/ip-installer-list-controller-request.service';
import { TourDateChangeService } from '../../tour/tour-page/service/tour-date-change.service';
import { AbstractImmoOverviewComponent } from '../abstract-immo-overview.component';
import { AuthService } from '../../../../services/auth.service';
import { ImmoStudioEmployeeWithProfile } from '../../../../model/tour/immo-studio-employee-with-profile';

@Component({
  selector: 'studio-immo-overview',
  templateUrl: './studio-immo-overview.component.html',
  styleUrls: ['./studio-immo-overview.component.scss'],
})
export class StudioImmoOverviewComponent
  extends AbstractImmoOverviewComponent<ImmoStudioTour>
  implements OnInit
{
  @Output()
  countChange = new EventEmitter<number>();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  includeUnassigned: boolean = false;

  amountsGrouped: ImmoStudioEmployeeAggregates[] = [];

  assignTourId: number;
  atelierDate: Date;

  assignOpen: boolean = false;

  allPlacers: Employee[];

  filterDate: Date;

  constructor(
    protected filterStoreService: FilterStoreService,
    protected pageIndexService: PageIndexService,
    protected cd: ChangeDetectorRef,
    protected subProjectService: SubProjectControllerRequestService,
    protected _lightbox: Lightbox,
    protected router: Router,
    private tourDateChangeService: TourDateChangeService,
    private modalService: ModalService,
    private ipInstallerListControllerRequestService: IPInstallerListControllerRequestService,
    private atelierUnassignTourControllerRequestService: AtelierUnassignTourControllerRequestService,
    private atelierService: AtelierService,
    private authService: AuthService
  ) {
    super(
      [
        //Filters go here
      ],
      filterStoreService,
      pageIndexService,
      cd,
      subProjectService,
      _lightbox,
      router
    );
  }

  ngOnInit() {
    const earlierStoredDate = this.atelierService
      .getSelectedAtelierDateSubscribable()
      .getValue();
    this.filterDate =
      earlierStoredDate == null ? new Date() : earlierStoredDate;
    this.includeUnassigned =
      this.tourDateChangeService.getUnassignedCheck().value;
    this.getAllPlacers();

    super.ngOnInit();
    this.fetchAggregates();
  }

  public override openTour(subProject: ImmoStudioTour): void {
    throw new Error('Method not implemented.');
  }
  public override copyProjectId(subProject: ImmoStudioTour): void {
    throw new Error('Method not implemented.');
  }

  private getAllPlacers() {
    this.ipInstallerListControllerRequestService
      .IPInstallerList()
      .then((placers: Employee[]) => (this.allPlacers = placers));
  }

  protected getPaginator(): MatPaginator {
    return this.paginator;
  }

  protected override initDisplayedColumns(): void {
    this.displayedColumns = [
      'placer',
      'tourDate',
      'branch',
      'atelierDate',
      'atelierEmployee',
      'reviewEmployee',
      'nbToPlace',
      'nbSold',
      'nbAdjustment',
      'route',
      'finished',
      'reviewed',
      'actions',
    ];
  }

  protected override initSortSettings(): void {
    //Sorting is currently hardcoded in backend
  }

  protected override fetchItems(): void {
    this.loading = true;
    this.items = [];

    this.subProjectService
      .getImmoStudio(
        this.generateFilterString(),
        this.paginator.pageSize,
        this.paginator.pageIndex,
        this.includeUnassigned,
        moment(this.filterDate).format('YYYY-MM-DD')
      )
      .then((res) => {
        this.processPageResult(res);
        this.totalItems = res.totalItems;
        this.items = res.items;
        this.countChange.emit(this.totalItems);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private fetchAggregates(): void {
    this.loading = true;
    this.items = [];

    this.subProjectService
      .getImmoStudioEmployeeAggregates(
        moment(this.filterDate).format('YYYY-MM-DD')
      )
      .then((res) => {
        this.amountsGrouped = res;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public override openProject(tour: ImmoStudioTour) {
    //TODO
  }

  public unassignTour(tour: ImmoStudioTour): void {
    this.modalService.confirmDialog(
      'Toewijzing ongedaan maken',
      'Bent u zeker dat u de toewijzing van deze toer ongedaan wilt maken?',
      (b) => {
        if (b) {
          this.doUnassignTour(tour.id);
        }
      }
    );
  }

  private doUnassignTour(tourId: number): void {
    this.loading = true;
    this.atelierUnassignTourControllerRequestService
      .unassignTour(tourId)
      .then(() => {
        this.fetchItems();
        this.fetchAggregates();
      })
      .catch((err) => {
        this.loading = false;
        throw err;
      });
  }

  protected override getLocalStorageKey(): string {
    return 'StudioImmoOverviewComponent';
  }

  includeUnassignedChanged() {
    this.tourDateChangeService
      .getUnassignedCheck()
      .next(this.includeUnassigned);
    this.fetchItems();
  }

  openEmployeeTourEditModal(row: ImmoStudioTour): void {
    this.modalService.openComponentInModal(
      EmployeeTourEditModalComponent,
      [
        { key: 'placer', value: this.toEmployee(row.placer) },
        { key: 'tourId', value: row.id },
        {
          key: 'tourDate',
          value: DateHelper.parseMoment(row.date),
        },
        { key: 'placerOptions', value: this.allPlacers },
        { key: 'hideRepos', value: true },
      ],
      null,
      { minWidth: '97vw', height: '95vh' }
    );
  }

  private toEmployee(studioEmployee: ImmoStudioEmployee): Employee {
    if (studioEmployee == null) {
      return null;
    }
    return this.allPlacers.find((e) => e.id === studioEmployee.id);
  }

  dateChange(date: moment.Moment) {
    this.filterDate = date.toDate();
    this.atelierService.setSelectedAtelierDate(this.filterDate);
    this.fetchItems();
    this.fetchAggregates();
  }

  public atelierAssigneeChanged() {
    this.toggleAssignModal();
    this.fetchItems();
    this.fetchAggregates();
  }

  public toggleAssignModal(tour?: ImmoStudioTour) {
    if (tour && tour.id != this.assignTourId) {
      this.assignTourId = tour.id;
      this.assignOpen = true;
    } else {
      this.assignTourId = null;
      this.assignOpen = false;
    }
  }

  public impersonateUser(employee: ImmoStudioEmployeeWithProfile) {
    this.authService.impersonateUser({ id: employee.userId });
  }

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement) {
      return;
    }
    const assignContainer = document.getElementsByClassName('assign-container');
    if (assignContainer.length > 0) {
      const clickedInside = assignContainer.item(0).contains(targetElement);
      const cdkContainer = document.getElementsByClassName(
        'cdk-overlay-container'
      );
      const clickCdk =
        cdkContainer.length > 0
          ? cdkContainer.item(0).contains(targetElement)
          : false;

      const classArr = [
        'btn--assign',
        'icon--assign',
        'mat-calendar-body',
        'mat-calendar-body-cell-content',
      ];
      const targetClassArr = [].slice.apply(targetElement.classList);
      const hasClass = targetClassArr.some((c) => classArr.includes(c));
      if (!clickedInside && !clickCdk && !hasClass) {
        this.toggleAssignModal();
      }
    }
  }
}
